// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

hr {
  margin-bottom: 0.5rem !important;
  margin-top: 0.5rem !important;
}

.image-size {
  flex-shrink: 1;
  max-width: 100%;
}

.box-height {
  height: 40vh;
  width: 100%;
}

.image-height {
  max-height: 40vh;
  max-width: 100%;
}

.gallery-height {
  height: 15vh;
}

.image-border {
  border: 1px #000 solid;
}

.image-cursor {
  cursor: pointer;
}

.justify-button {
  justify-content: center;
  display: grid;
}

@media (max-width: 576px) {
  .hide-gallery {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./projects/zbs-app/src/app/modules/article/components/article-detail/article-detail.component.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;EACA,gBAAA;EACA,uBAAA;AACJ;;AAEA;EACI,gCAAA;EACA,6BAAA;AACJ;;AAEA;EAGI,cAAA;EACA,eAAA;AADJ;;AAIA;EACI,YAAA;EACA,WAAA;AADJ;;AAIA;EACI,gBAAA;EACA,eAAA;AADJ;;AAIA;EACI,YAAA;AADJ;;AAIA;EACI,sBAAA;AADJ;;AAIA;EACI,eAAA;AADJ;;AAIA;EACI,uBAAA;EACA,aAAA;AADJ;;AAIA;EACI;IACI,aAAA;EADN;AACF","sourcesContent":[".ellipsis {\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\nhr {\r\n    margin-bottom: 0.5rem !important;\r\n    margin-top: 0.5rem !important;\r\n}\r\n\r\n.image-size {\r\n    //max-height: inherit !important;\r\n    //max-width: inherit !important;\r\n    flex-shrink: 1;\r\n    max-width: 100%;\r\n}\r\n\r\n.box-height {\r\n    height: 40vh;\r\n    width: 100%;\r\n}\r\n\r\n.image-height {\r\n    max-height: 40vh;\r\n    max-width: 100%;\r\n}\r\n\r\n.gallery-height {\r\n    height: 15vh;\r\n}\r\n\r\n.image-border {\r\n    border: 1px #000 solid;\r\n}\r\n\r\n.image-cursor {\r\n    cursor: pointer;\r\n}\r\n\r\n.justify-button {\r\n    justify-content: center;\r\n    display: grid;\r\n}\r\n\r\n@media (max-width: 576px) {\r\n    .hide-gallery {\r\n        display: none;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
